import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { formatImageUrl } from "../../../helper/helper";
import DuncanTaylorVideo from "../common/duncanTaylorVideo";
import Button from "../common/CommonButton/Button";

const NewOctaveCollectionDetails = (props: any) => {
  const [isMobile, setIsMobile] = useState(false);
  let [isClicked, setIsClicked] = useState(false);
  const [activeTab, setActiveTab] = useState("whisky-section");

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth < 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  let logoImage: any = formatImageUrl(props?.data?.logo?.data?.attributes?.url);
  let mediaImage: any = "/octave-collection-new/secondfoldthumbnailnew.png";
  let mediaImageMobile: any =
    "/octave-collection-new/secondfoldthumbnailnew.png";

  const handleClick = (id: string) => {
    const section: any = document.getElementById(id);
    if (section) {
      setActiveTab(id);
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="octave_collection_new_details">
      <h5 className="how_we_make_title new_octave_collection_title new_octave_title_margin_bottom for_mobile">
        {props?.data?.header}
      </h5>

      {/* <div className="new_octave_craft_tab">
        <div
          className={`inner_tab ${
            activeTab === "whisky-section" ? "active" : ""
          }`}
          onClick={() => handleClick("whisky-section")}
        >
          HOW WE CRAFT THE OCTAVE
        </div>
        <div
          // className="inner_tab"
          className={`inner_tab ${
            activeTab === "explore-range-section" ? "active" : ""
          }`}
          onClick={() => handleClick("explore-range-section")}
        >
          EXPLORE THE RANGE
        </div>
        <div
          className={`inner_tab ${
            activeTab === "journery-section" ? "active" : ""
          }`}
          onClick={() => handleClick("journery-section")}
        >
          EXPERIENCE THE JOURNEY
        </div>
        <div
          className={`inner_tab ${
            activeTab === "cask-section" ? "active" : ""
          }`}
          onClick={() => handleClick("cask-section")}
        >
          BOTTLE A CASK
        </div>
      </div> */}

      <div className="collection_container">
        <h4>{props?.data?.sub_title}</h4>

        <Row>
          <Col sm={12} md={12} lg={6}>
            <div className="octave_collection_new_details_text ">
              <div className="inner_div">
                {/* <h2>{props?.data?.title}</h2> */}
                {/* {props?.data?.logo?.data && (
                  <img src={logoImage} alt={`bottle`} className="octave_logo" />
                )} */}

                <p>{props?.data?.content1}</p>
                <p>{props?.data?.content2}</p>
                <p>{props?.data?.content3}</p>
              </div>
            </div>
          </Col>
          <Col sm={12} md={12} lg={6}>
            <div className="octave_collection_new_text_outer_div">
              {isClicked ? (
                <DuncanTaylorVideo
                  data={
                    props?.data?.video_link
                    // "https://images.dtstage.com/dt-website/octave-introduction.mp4"
                  }
                  classforvideo="newoctave_collection_secondfold_videoplaycontainer"
                />
              ) : (
                <div className="thumbnail_wrapper ">
                  <img
                    src={isMobile ? mediaImageMobile : mediaImage}
                    alt={`logo`}
                    className="octave_logo thumbnail_image"
                  />

                  <div
                    onClick={() => setIsClicked(true)}
                    className="thumbnail_btn"
                  >
                    <img
                      src={"/octave-collection-new/youtube.svg"}
                      alt={`thumnail`}
                      className=""
                    />
                  </div>
                </div>
              )}
              {/* {data?.cta?.link ? ( */}
              <Button
                btnText={"click here to watch the full video"}
                btnClass={"watch_all_episodes"}
                btnLink={props?.data?.youtube_link}
                // btnLink={"https://www.youtube.com/@DuncanTaylorScotchWhiskyLtd"}
                linkOpenState={
                  props?.data?.cta?.open_in_new_tab == true
                    ? "_blank"
                    : "_blank"
                }
              />
              {/* ) : null} */}
              {/* <div className="inner_octave_text">
                <h6>
                  The Octave Collection is extensive, covering a wide range of
                  whisky styles.
                </h6>
              </div> */}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default NewOctaveCollectionDetails;
